<template>
  <the-content>
    <div class="heading">
      <h1 class="heading-title">Сообщения</h1>
      <div class="heading-buttons">
        <message-create-dialog @sent="onSent">
          <template v-slot:default="{on: onDialog}">
            <v-tooltip bottom>
              <template v-slot:activator="{on: onTooltip}">
                <v-btn color="blue"
                       dark
                       :fab="$vuetify.breakpoint.mdAndDown"
                       :small="$vuetify.breakpoint.mdAndDown"
                       v-on="{...onDialog, ...onTooltip}"
                >
                  <v-icon :left="$vuetify.breakpoint.lgAndUp">mdi-email-plus</v-icon>
                  <span class="d-none d-lg-block">Новое сообщение</span>
                </v-btn>
              </template>
              <span>Написать новое сообщение</span>
            </v-tooltip>
          </template>
        </message-create-dialog>
      </div>
    </div>

    <v-card class="clients-table">
      <v-data-table
        :headers="headers"
        :items="messages"
        :options.sync="options"
        :server-items-length="totalMessages"
        :loading="loading"
        :footer-props="footerProps"
        :must-sort="true"
        :multi-sort="false"
      >
        <template v-slot:item.recipients="{item}">
          <div class="td-recipients">
            <div class="td-recipients__text" :title="getRecipientNames(item.recipients).join(', ')">
              {{ getRecipientNames(item.recipients).join(', ') }}
            </div>
          </div>
        </template>
        <template v-slot:item.text="{item}">
          <div class="td-message">
            <div class="td-message__text" :title="item.text">{{ item.text }}</div>
          </div>
        </template>
        <template v-slot:item.created_at="{item}">
          <div class="td-date">
            {{ $dayjs(item.created_at).format('DD MMMM YYYY в HH:mm') }}
          </div>
        </template>
        <template v-slot:item.action="{item}">
          <div class="td-actions">
            <div class="td-actions__item">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn color="primary"
                         depressed
                         :x-small="$vuetify.breakpoint.smAndUp"
                         :fab="$vuetify.breakpoint.smAndUp"
                         :small="$vuetify.breakpoint.xsOnly"
                         :block="$vuetify.breakpoint.xsOnly"
                         @click.stop="showMessage=item.id"
                         v-on="on"
                  >
                    <v-icon :left="$vuetify.breakpoint.xsOnly">mdi-eye</v-icon>
                    <span v-if="$vuetify.breakpoint.xsOnly">Подробнее</span>
                  </v-btn>
                </template>
                <span>Смотреть подробнее</span>
              </v-tooltip>
            </div>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <message-show-dialog :messageId="showMessage" @close="showMessage=false"/>
  </the-content>
</template>

<script>
import messageApi from '../api/message.api';
import MessageCreateDialog from '../components/MessageCreateDialog';
import MessageShowDialog from '../components/MessageShowDialog';
import { mapState } from 'vuex';

export default {
  name      : 'MessagesPage',
  components: { MessageShowDialog, MessageCreateDialog },
  props     : {
    page: {
      required: false,
      default : 1,
    }
  },
  data() {
    return {
      options      : {
        itemsPerPage: 15,
        sortBy      : ['created_at'],
        sortDesc    : [true],
        page        : this.page,
      },
      headers      : [
        { text: 'Получатели', value: 'recipients', class: 'th-recipients', sortable: false },
        { text: 'Текст', value: 'text', class: 'th-message', sortable: false },
        { text: 'Дата', value: 'created_at', class: 'th-date' },
        { text: '', value: 'action', class: 'th-actions', sortable: false, filterable: false },
      ],
      loading      : true,
      footerProps  : {
        itemsPerPageOptions: [15, 30, 45],
        showCurrentPage    : true,
        itemsPerPageText   : 'Сообщений на странице',
      },
      messages     : [],
      showMessage  : false,
      totalMessages: 0,
    };
  },
  computed: {
    ...mapState({
      clients: state => state['clients'].items,
    }),
  },
  watch   : {
    options: {
      handler() {
        this.updateRoute();
      },
      deep: true,
    },
    page() {
      this.options.page = this.page;
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.fetchMessages();
    next();
  },
  methods: {
    fetchMessages() {
      this.loading = true;

      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      return messageApi.all({
        page,
        itemsPerPage,
        sortBy       : sortBy.length ? sortBy[0] : 'created_at',
        sortDirection: sortDesc[0] === true ? 'DESC' : 'ASC',
      }).then(({ data }) => {
        this.loading       = false;
        this.messages      = data.data;
        this.totalMessages = data.meta.total;
      }).catch(() => {
        this.$toast.error('Что-то пошло не так. Пожалуйста, повторите попытку позже');
      });
    },
    onSent() {
      this.$store.commit('setLoading', true);
      this.fetchMessages().finally(() => {
        this.$store.commit('setLoading', false);
      });
    },
    getRecipientNames(recipients) {
      const recipientsArr = recipients.split(',');
      const names         = [];
      recipientsArr.forEach((id) => {
        if ('all' === id) {
          return names.push('Все');
        }

        if ('lost' === id) {
          return names.push('Потерянные клиенты');
        }

        const recipient = this.clients.find((item) => item.id == id);
        if (recipient) {
          names.push(recipient.name);
        }
      });
      return names;
    },
    updateRoute() {
      this.$router.push({
        name: 'messages.list', query: {
          page: this.options.page,
        }
      }).catch(() => {
        this.fetchMessages();
      });
    }
  }
};
</script>

<style scoped>

</style>
